// extracted by mini-css-extract-plugin
export default {"toaster-container":"Toaster_toaster-container__s80Ty","close-icon":"Toaster_close-icon__mCA8G"};